import * as THREE from 'three';
import { BaseEnemy } from './base.js';
import { ENEMY_STATS } from '../../data/enemies.data.js';
import { circleVsCircle } from '../../engine/collision.js';

const ZEALOT_SPEED_AS_DRONE = ENEMY_STATS.drone.moveSpeed / ENEMY_STATS.zealot.moveSpeed;

export class Zealot extends BaseEnemy {
  constructor(opts) {
    super({ ...opts, stats: ENEMY_STATS.zealot });
    this.meleeTimer = 0;
    this.windup = 0;
  }

  buildMesh() {
    super.buildMesh();
    // Shock baton (glowing stick, held out)
    const baton = new THREE.Mesh(
      new THREE.BoxGeometry(0.18, 0.18, 1.1),
      new THREE.MeshStandardMaterial({
        color: this.stats.accentColor,
        emissive: this.stats.accentColor,
        emissiveIntensity: 0.9,
      })
    );
    baton.position.set(0.4, 1.05, 0.6);
    baton.castShadow = true;
    this.group.add(baton);
    this._baton = baton;
  }

  updateAI(dt, game) {
    const player = game.player;
    if (!player.alive) return;
    const d = this.distTo(player.x, player.z);
    this.sensePlayer(game, dt);

    const targetX = player.x;
    const targetZ = player.z;

    this.aimX = targetX - this.x;
    this.aimZ = targetZ - this.z;
    const aimLen = Math.hypot(this.aimX, this.aimZ) || 1;
    this.aimX /= aimLen; this.aimZ /= aimLen;

    if (this.windup > 0) {
      this.windup -= dt;
      // Telegraph: baton glows brighter, no movement
      if (this._baton) this._baton.material.emissiveIntensity = 2.5 + Math.sin(this.stateTime * 40) * 0.6;
      if (this.windup <= 0) {
        // Swing
        if (circleVsCircle(this.x, this.z, this.stats.attackRange, player.x, player.z, player.radius)) {
          player.takeDamage(this.stats.meleeDamage, game);
        }
        if (this._baton) this._baton.material.emissiveIntensity = 0.9;
        this.fireCd = this.stats.fireCooldown;
        this.state = 'cooldown';
      }
      return;
    }

    if (this._lastCanSeePlayer && d < this.stats.attackRange && this.fireCd <= 0) {
      this.state = 'windup';
      this.windup = this.stats.meleeWindup;
      return;
    }

    this.state = 'chase';
    this.moveWithPathfinding(targetX, targetZ, dt, game, ZEALOT_SPEED_AS_DRONE);
  }
}
